import { createFileRoute } from "@tanstack/react-router";

import { ConsolePlan } from "../features/console/account";

export const Route = createFileRoute("/console/plan")({
  component: ConsolePlan,
});
